import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jsmGSPPageRoute: InvariantJiraRoute = {
	name: 'servicedesk-getting-started-page',
	path: '/jira/servicedesk/projects/:projectKey/getting-started',
	exact: true,
};
